import { defineMessages, useIntl } from 'react-intl';
import { TextLabel1 } from '@cbhq/cds-web/typography';

const messages = defineMessages({
  manageAccount: {
    id: 'identity.profile.menu.manageAccount',
    defaultMessage: 'Manage account',
  },
});

export function ManageAccountCTA() {
  const { formatMessage } = useIntl();

  return (
    <TextLabel1 as="p" color="fgPrimary" paddingTop={1} display="block">
      {formatMessage(messages.manageAccount)}
    </TextLabel1>
  );
}
